import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { get } from 'lodash'
import { push } from 'connected-react-router'
import { compose } from 'recompose'
import { modal, wizard } from 'helpers/decorators'
import { Checkbox, Textarea } from 'components/fields'
import { Title, Note, FormDebug, Button, AssessorFileCard, FieldError } from 'components/misc'
import { FormattedMessage } from 'react-intl'
import { apiAssessors } from 'helpers/decorators/api'
import queryString from 'query-string'
import config from 'config'
import { activityCategoryRegistrationInitialValues } from 'models/assessor'
import validate from './qualification.validation'
import { AssessorFileUploadModal, AssessorFileDeleteModal } from '../../../../components/modals'
import MODALS from '../../../../constants/layout/modals'
import { ElevatedButton } from '../../../../components/layout'
import { FileLoader } from '../../../../components/loaders'
import { getId } from '../../../../helpers/assessorFileHelper'
import styles from './qualification.styl'

const enhance = compose(
  apiAssessors(),
  modal.trigger(),
  wizard({
    form: 'assessorRegistration',
    multipage: true,
    validate,
    destroyOnUnmount: false
  }),
  connect(state => ({
    data: get(state.api.assessor.registration, 'data', {}),
    fileUploading: state.api.blob.loading,
    files: get(state.api.assessor.registration.files, 'data', []),
    filesLoading: get(state.api.assessor.registration.files, 'loading'),
    submitFailed: get(state.form, 'assessorRegistration.submitFailed'),
  }), { push })
)

class AssessorQualification extends Component {
  static propTypes = {
    data: PropTypes.object.isRequired,
    assessor: PropTypes.object,
    push: PropTypes.func,
    handleSubmit: PropTypes.func,
    values: PropTypes.object,
    errors: PropTypes.object,
    onSubmit: PropTypes.func,
    location: PropTypes.object,
    onLoadAssessorActivityCategoryRegistration: PropTypes.func,
    initialize: PropTypes.func,
    onCreateActivityCategoryRegistration: PropTypes.func.isRequired,
    change: PropTypes.func,
    onOpen: PropTypes.func,
    onClose: PropTypes.func,
    onUploadAssessorFile: PropTypes.func,
    onLoadAssessorFile: PropTypes.func,
    onDeleteAssessorFile: PropTypes.func,
    fileUploading: PropTypes.bool,
    filesLoading: PropTypes.bool,
    files: PropTypes.array,
    modalObj: PropTypes.object
  }

  async componentDidMount() {
   const query = queryString.parse(get(this.props, 'location.search'))

    const authCode = get(query, 'authorizationCode')

    if (!authCode) {
      this.props.push(`${config.publicPath}/`)
    }

    const assRes = await this.props.onLoadAssessorActivityCategoryRegistration(authCode)

    const body = get(assRes, 'body')

    if (body) {
      this.props.initialize(activityCategoryRegistrationInitialValues(body))

      const id = getId(body)

      const assessorId = get(body, 'assessor.id')

      id && assessorId && this.props.onLoadAssessorFile(id, assessorId, authCode)
    }
  }

  getData = data => {
    let preparedData = {}

    preparedData.assessorId = get(data, 'assessor.id')
    preparedData.organizationName = get(data, 'assessor.organization.name')

    if (get(data, 'activity')) {
      preparedData.activityId = get(data, 'activity.id')
      preparedData.participantName = get(data, 'activity.award.participant.name')
      preparedData.activitySection = get(data, 'activity.activitySection.translationText')
      preparedData.activitySubCategory = get(data, 'activity.activityCategory.translatedName')
      preparedData.activityCategory = get(data, 'activity.activityCategory.parent.translatedName')
    }

    if (get(data, 'activityCategory')) {
      preparedData.activityCategoryId = get(data, 'activityCategory.id')
      preparedData.participantName = ''
      preparedData.activitySection = get(data, 'activityCategory.activitySection.translationText')
      preparedData.activitySubCategory = get(data, 'activityCategory.translatedName')
      preparedData.activityCategory = get(data, 'activityCategory.parent.translatedName')
    }

    if (get(data, 'ajEvent')) {
      preparedData.ajEventId = get(data, 'ajEvent.id')
      preparedData.participantName = get(data, 'ajEvent.award.participant.name')
      preparedData.activitySection = get(data, 'ajEvent.activityCategory.activitySection.translationText')
      preparedData.activitySubCategory = get(data, 'ajEvent.activityCategory.translatedName')
      preparedData.activityCategory = get(data, 'ajEvent.activityCategory.parent.translatedName')
    }

    if (get(data, 'residentialProject')) {
      preparedData.residentialProjectId = get(data, 'residentialProject.id')
      preparedData.participantName = get(data, 'residentialProject.award.participant.name')
      preparedData.activitySection = get(data, 'residentialProject.activityCategory.activitySection.translationText')
      preparedData.activitySubCategory = get(data, 'residentialProject.activityCategory.translatedName')
      preparedData.activityCategory = get(data, 'residentialProject.activityCategory.parent.translatedName')
    }

    return preparedData
  }

  handleSubmit = (fields, submitData) => {
    const query = queryString.parse(get(this.props, 'location.search'))

    const authCode = get(query, 'authorizationCode')

    return this.props.onCreateActivityCategoryRegistration(fields, submitData, authCode)
      .then(() => {
        this.props.onSubmit()
        this.props.reset()
      })
      .catch(err => console.debug(err))
  }

  render() {
    const {
      data,
      assessor,
      handleSubmit,
      values,
      errors,
      fileUploading,
      filesLoading,
      files,
      modalObj
    } = this.props

    const isLoading = get(assessor, 'profile.isLoading')

    const preparedData = this.getData(data)

    const organizationName = get(preparedData, 'organizationName')

    const participantName = get(preparedData, 'participantName')

    const activitySection = get(preparedData, 'activitySection')

    const activitySubCategory = get(preparedData, 'activitySubCategory')

    const activityCategory = get(preparedData, 'activityCategory')

    const activityCategoryId = get(preparedData, 'activityCategoryId')

    const activityId = get(preparedData, 'activityId')

    const ajEventId = get(preparedData, 'ajEventId')

    const residentialProjectId = get(preparedData, 'residentialProjectId')

    const id = activityId || ajEventId || residentialProjectId || activityCategoryId

    const assessorId = get(preparedData, 'assessorId')

    const query = queryString.parse(get(this.props, 'location.search'))

    const authCode = get(query, 'authorizationCode')

    const qualificationsError = errors?.peakBody

    const submitFailed = get(this.props, 'submitFailed')

    const withoutAssessor = false

    const submitData = {
      assessorId,
      activityId,
      activityCategoryId,
      ajEventId,
      residentialProjectId
    }

    return (
      <div>
      <form onSubmit={handleSubmit((fields) => this.handleSubmit(fields, submitData))}>
        <Title h1>
          <FormattedMessage
            id="moduleTitle.welcome_to_the_orb"
            defaultMessage="Welcome to the Online Record Book"
          />
        </Title>

        <div className="row">
          <Note margin="0 0 0 15px" hideNodePrefix={true}>
        <FormattedMessage
          id="label.desc_au_and_participant"
          defaultMessage="{organizationName} for participant {participantName}"
          values={{
            organizationName,
            participantName
          }}
        />
          </Note>
        <br />
          <Note margin="0 0 40px 15px" hideNodePrefix={true}>
          <FormattedMessage
            id="label.desc_activity_detail"
            defaultMessage="For {activitySection} - {activityCategory} - {activitySubCategory}"
            values={{
              activitySection,
              activityCategory,
              activitySubCategory
            }}
          />
          </Note>
        </div>

        <Note lighter margin="0 0 10px 0">
          <FormattedMessage
            id="label.all_qualifications_currently_hold"
            defaultMessage="Please tick all qualifications you currently hold."
          />
        </Note>

        <div className="row">
          <div className="col-md-3">
            <Checkbox
              name="universityDegree"
              label="University Degree"
              intlKey="label.university_degree"
            />
          </div>
          <div className="col-md-3">
            <Checkbox
              name="tafeQualification"
              label="TAFE Qualification"
              intlKey="label.tafe_qualification"
            />
          </div>
          <div className="col-md-3">
            <Checkbox
              name="apprenticeship"
              label="Apprenticeship"
              intlKey="label.apprenticeship"
            />
          </div>
          <div className="col-md-3">
            <Checkbox
              name="experience"
              label="Work Experience"
              intlKey="label.work_experience"
            />
          </div>
        </div>

        <div className="row">
          <div className="col-md-3">
            <Checkbox
              name="membership"
              label="Membership"
              intlKey="label.membership"
            />
            <FieldError className={styles.qualificationsError} toShow={submitFailed} message={qualificationsError} />
          </div>
          <div className="col-md-3">
            <Checkbox
              name="nonAccreditedTraining"
              label="Non-accredited Training"
              intlKey="label.non_accredited_training"
            />
          </div>
          <div className="col-md-3">
            <Checkbox
              name="organisational"
              label="Organisational"
              intlKey="label.organisational"
            />
          </div>
          <div className="col-md-3">
            <Checkbox
              name="peakBody"
              label="Peak Body"
              intlKey="label.peak_body"
            />
          </div>
        </div>

        <div className="row">
          <div className="col-xs-12 col-md-12">
            <Textarea
              name="relevantExperience"
              label="Please enter all relevant experience you have to support the activities you will be assessing (200 characters)*"
              intlKey="label.relevant_experience_desc"
              maxLength={200}
            />
          </div>
        </div>

        <div className="row">
          <div className="col-xs-12 col-md-12">
            <Checkbox
              name="isPublicAvailable"
              label="I am happy to assess activities for other participants -> if no then you are not listed among assessor."
              intlKey="label.i_am_happy_to_assess_other_participants_activities"
            />
          </div>
        </div>


        <div>
        <p className="note">
          <FormattedMessage
            id="label.assessor_registration_upload_file_with_assessed_activity"
            defaultMessage="You can upload here any files related with assessed activity."
          />
        </p>
        {!filesLoading.loading ? (
          <div className="row">
            {files && files.map(item => (
                <div key={item.id} className="col-xs-12 col-sm-6">
                  <AssessorFileCard
                    src={item.fileUrl}
                    file={item}
                    fileId={item.id}
                    onDeleteClick={() =>
                      this.props.onOpen(MODALS.ASSESSOR_FILE_DELETE, null, {
                        id,
                        assessorId,
                        item,
                        authCode,
                        withoutAssessor
                      })
                    }
                  />
                </div>
              ))
              .reverse()
            }
          </div>
        ) : (
          <FileLoader />
        )}

        <ElevatedButton
          onClick={() => this.props.onOpen(MODALS.ASSESSOR_FILE_UPLOAD)}
          intlKey="button.upload_file"
          rounded
          uppercase
        >
          Upload file
        </ElevatedButton>
        </div>

        <FormDebug values={values} errors={errors} />
        <div style={{ marginTop: '60px', float: 'right' }}>
          <Button type="submit" disabled={isLoading}>
            <FormattedMessage id="button.finish" defaultMessage="Finish" />
          </Button>
        </div>
      </form>

      <AssessorFileUploadModal
        modalId={MODALS.ASSESSOR_FILE_UPLOAD}
        onSubmit={this.props.onUploadAssessorFile}
        assessorId={assessorId}
        activityId={activityId}
        ajEventId={ajEventId}
        activityCategoryId={activityCategoryId}
        residentialProjectId={residentialProjectId}
        authCode={authCode}
        loading={fileUploading}
        withoutAssessor={withoutAssessor}
      />
      <AssessorFileDeleteModal
          modalId={MODALS.ASSESSOR_FILE_DELETE}
          onClose={this.props.onClose}
          onConfirm={() => this.props.onDeleteAssessorFile(modalObj.data)}
       />
     </div>
    )
  }
}

export default enhance(AssessorQualification)

